import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import * as React from "react";
import Component from "src/shared/components/Component";
import Modal from "src/shared/components/Modal";
import Page from "src/shared/components/Page";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import { ISport, ISportData } from "src/api/types";
import { ISportAdminPageProps } from "./IAdminPageProps";
import SportListItem from "./sportsPage/SportListItem";

const styles = () => ({});

interface ISportsPageState {
  sportName: string;
  deleteSport?: any;
  loading?: true;
  submitting?: true;
  error?: true;
  modalVisible: boolean;
}

type IProps = ISportAdminPageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

export default withStyles(styles)(
  withAxios(
    class extends Component<IProps, ISportsPageState> {
      public readonly state = this.buildState({
        modalVisible: false,
        sportName: "",
      });

      private readonly handleSportChange = this.stateInputEventHandler((v) => ({
        sportName: v,
      }));

      public componentDidMount() {
        this.props.loadSports();
      }

      public render() {
        const { sportName } = this.state;
        return (
          <Page header="Manage Sports">
            <form onSubmit={this.addSport}>
              <Grid
                container={true}
                direction="row"
                spacing={2}
                alignItems="center"
              >
                <Grid item={true}>
                  <TextField
                    label="Sport"
                    value={sportName}
                    onChange={this.handleSportChange}
                  />
                </Grid>
                <Grid>
                  <Button
                    type="submit"
                    disabled={!this.canSubmit()}
                    variant="contained"
                    color="primary"
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </form>
            {this.renderTemplateList()}
            {this.renderDeleteModal()}
          </Page>
        );
      }

      private renderDeleteModal() {
        const { deleteSport, modalVisible } = this.state;
        if (deleteSport === undefined) {
          return null;
        }
        return (
          <Modal open={modalVisible} closeModal={this.closeModal}>
            <Grid
              style={{ height: "100%" }}
              container={true}
              direction="column"
              justifyContent="space-between"
            >
              <Grid>
                <h1>{deleteSport.name}</h1>
                <span>Are you sure you want to delete {deleteSport.name}?</span>
              </Grid>
              <Grid container={true} justifyContent="space-between">
                <Button onClick={this.closeModal} variant="contained">
                  Back
                </Button>
                <Button
                  onClick={this.deleteSport}
                  variant="contained"
                  color="secondary"
                >
                  Delete
                </Button>
              </Grid>
            </Grid>
          </Modal>
        );
      }

      private renderTemplateList() {
        const { loadSports, loadingSports, sports, setSport } = this.props;
        return (
          <List>
            {loadingSports && <LinearProgress />}
            {sports.map((sport) => (
              <SportListItem
                loadSports={loadSports}
                key={sport.id}
                sport={sport}
                openDeleteModal={this.openDeleteModal}
                setSport={setSport}
              />
            ))}
          </List>
        );
      }

      private closeModal = () => this.setState({ modalVisible: false });

      private openDeleteModal = (deleteSport: ISport) => () =>
        this.setState({ modalVisible: true, deleteSport });

      private canSubmit = () => {
        const { submitting, sportName } = this.state;
        return Boolean(sportName.trim()) && submitting === undefined;
      };

      private addSport = async (e: React.FormEvent) => {
        e.preventDefault();
        this.runCancellableStatefulAsync(
          this,
          {
            submitting: true,
          },
          {
            sportName: "",
            submitting: undefined,
          },
          async () => {
            await this.buildPost<ISportData, void>(
              this,
              "sport"
            )({
              name: this.state.sportName.trim(),
            });
            this.props.loadSports();
          },
          () => {
            window.alert("Failed to add sport");
            this.setState({ submitting: undefined });
          }
        );
      };

      private deleteSport = () =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {
            modalVisible: false,
          },
          async () => {
            const { deleteSport } = this.state;
            if (deleteSport !== undefined) {
              await this.buildDelete<void>(this, `sport/${deleteSport.id}`)();
              this.props.loadSports();
            }
          },
          () => {
            window.alert("Failed to delete sport");
          }
        );
    }
  )
);



// WEBPACK FOOTER //
// ./src/features/admin/pages/SportsPage.tsx